import
  React
from 'react';

export default ({
  size = '49'
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 39 49"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#333333"
      d="M0 7.64706C0 3.4237 3.42371 0 7.64706 0H29.2444C32.3033 3.44118 34.7941 6.11769 39 10.3235V41.2941C39 45.5175 35.5763 48.9412 31.3529 48.9412H7.64706C3.4237 48.9412 0 45.5175 0 41.2941V7.64706Z"
    />
    <path
      fill="#999999"
      d="M32.9089 10.6175C30.4863 10.7145 28.535 8.6512 28.7671 6.23777L29.3494 0.183484L38.9862 10.374L32.9089 10.6175Z"
    />
    <path
      fill="#CCCCCC"
      d="M7.34131 28.4706V19.9393H10.2651C11.23 19.9393 11.9644 20.1327 12.4683 20.5194C12.9722 20.9061 13.2241 21.4823 13.2241 22.2479C13.2241 22.6385 13.1187 22.9901 12.9077 23.3026C12.6968 23.6151 12.3882 23.8573 11.9819 24.0292C12.4429 24.1542 12.7983 24.3905 13.0483 24.7382C13.3022 25.0819 13.4292 25.496 13.4292 25.9803C13.4292 26.7811 13.1714 27.3964 12.6558 27.826C12.144 28.2557 11.4097 28.4706 10.4526 28.4706H7.34131ZM8.82373 24.621V27.287H10.4702C10.9351 27.287 11.2983 27.1718 11.5601 26.9413C11.8218 26.7108 11.9526 26.3905 11.9526 25.9803C11.9526 25.0936 11.4995 24.6405 10.5933 24.621H8.82373ZM8.82373 23.5311H10.2769C10.7378 23.5311 11.0972 23.4276 11.355 23.2206C11.6167 23.0096 11.7476 22.7128 11.7476 22.33C11.7476 21.9081 11.6265 21.6034 11.3843 21.4159C11.146 21.2284 10.7729 21.1346 10.2651 21.1346H8.82373V23.5311ZM16.8335 19.9393L19.2944 26.4784L21.7495 19.9393H23.6655V28.4706H22.189V25.6581L22.3354 21.8964L19.8159 28.4706H18.7554L16.2417 21.9022L16.3882 25.6581V28.4706H14.9116V19.9393H16.8335ZM26.9058 25.3007V28.4706H25.4233V19.9393H28.687C29.6401 19.9393 30.396 20.1874 30.9546 20.6835C31.5171 21.1796 31.7983 21.8358 31.7983 22.6522C31.7983 23.4882 31.5229 24.1385 30.9722 24.6034C30.4253 25.0682 29.6577 25.3007 28.6694 25.3007H26.9058ZM26.9058 24.1112H28.687C29.2144 24.1112 29.6167 23.9882 29.894 23.7421C30.1714 23.4921 30.3101 23.1327 30.3101 22.6639C30.3101 22.203 30.1694 21.8358 29.8882 21.5624C29.6069 21.285 29.2202 21.1425 28.728 21.1346H26.9058V24.1112Z"
    />
  </svg>
);